module.exports = __webpack_public_path__ + "img/msu3-char-1.8cbfa269.png";